import { useEffect, useState, useCallback } from "react";
import { getVideos, getTags } from "../lib/api";

/** Loads videos + tags from the backend and exposes a reload action. */
export function useLibraryData() {
  const [videos, setVideos] = useState([]);
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const reload = useCallback(async () => {
    try {
      const [vids, tg] = await Promise.all([getVideos(), getTags()]);
      setVideos(vids);
      setTags(tg);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  return { videos, tags, loading, error, reload, setLoading };
}
